/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_MY_HIGH_VALUE_LEAD,
  ADD_FOLLOWUP,
  UPDATE_SUBSTATUS,
  UPDATE_REJECT,
  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD,
  UPLOAD_FOLLOW_ATTACHMENT_RECORD,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadMyHighValueLead,
  loadMyHighValueLeadError,
  loadMyHighValueLeadSuccess,
  addFollowUpSuccess,
  addFollowUpError,
  updateSubStatusSuccess,
  updateSubStatusError,
  updateRejectSuccess,
  updateRejectError,
  loadRecordsAttachmentDetailDataSuccess,
  loadRecordsAttachmentDetailDataError,

  uploadFollowupAttachmentRecordDataSuccess,
  uploadFollowupAttachmentRecordDataError,

} from "./actions"

import {
  loadMyHighValueLeadApi,
  loadRecordsMetaData,
  addFollowUpAPI,
  updateSubStatusAPI,
  updateRejectAPI,
  loadRecordsAttachmentDetailData,
  uploadFollowupAttachmentRecordData,
} from "./remotes"


import { selectSession } from "../session/selectors"
import { roleIds } from "../../helpers/tools"


function* loadMyHighValueLeadSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_MY_HIGH_VALUE_LEAD),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadMyHighValueLead(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadMyHighValueLeadApi, searchvalue)
        console.log("api result is", result)

        if (result) {
          yield put(loadMyHighValueLeadSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadMyHighValueLeadSuccess([]))
          yield put(loadMyHighValueLeadError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadMyHighValueLeadSuccess([]))
        yield put(
          loadMyHighValueLeadError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}


function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      let sessionDetails
      while (true) {
        // eslint-disable-line no-constant-condition
        const sessionInStore = yield select(selectSession())

        const { user = {} } = sessionInStore
        if (user && Object.keys(user).length > 0) {
          sessionDetails = sessionInStore
          break
        }
        yield delay(500)
      }

      let company
      let branch
      if (
        sessionDetails &&
        sessionDetails.user &&
        roleIds.includes(sessionDetails.user.roleId)
      ) {
        company = yield call(loadRecordsMetaData, "company", "post")
        branch = yield call(loadRecordsMetaData, "branch", "post")
      } else {
        company =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.company &&
            sessionDetails.user.company.length > 0 &&
            sessionDetails.user.company.map((_) => _.detail)) ||
          []
        branch =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.branch &&
            sessionDetails.user.branch.length > 0 &&
            sessionDetails.user.branch.map((_) => _.detail)) ||
          []
      }
      const event = yield call(
        loadRecordsMetaData,
        "event",
        "post"
      )
      const employee = yield call ( loadRecordsMetaData,
        "employee_filter",
        "post")
      const processStatus = yield call(loadRecordsMetaData, "process_status", "post")
      const followupStrategy = yield call(loadRecordsMetaData,"followup_strategy", "post")
      const followupMode = yield call( loadRecordsMetaData,"followup_master","post")
      const followupAction = yield call( loadRecordsMetaData,"followup_action", "post")
      const clientProfile = yield call(loadRecordsMetaData, 'client_profile', 'post')
      const reject = yield call(loadRecordsMetaData,"rejectreason", "post")
      let permissionMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data.filter(_=> _.status === 1).map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data.filter(_=> _.status === 1).map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
          eventOptions:
        (event &&
          event.data &&
          event.data.length > 0 &&
          event.data
            .filter((_) => _.status === 1)
            .map((c) =>
              Object.assign(
                {},
                {
                  label: c.eventName,
                  value: c._id,
                  eventCode: c.eventCode,
                  //  companyId: c.companyId
                }
              )
            )) ||
        [],
        processStatusOptions:
        (processStatus &&
          processStatus.data &&
          processStatus.data.length > 0 &&
          processStatus.data
            .filter((_) => _.status === 1)
            .map((p) =>
              Object.assign(
                {},
                {
                  label: p.processStatus,
                  value: p.processStatusId,
                  processStatusId: p.processStatusId,
                  colorCode: p.colorCode,
                }
              )
            )) ||
        [],
        
        employeeOptions:
        (employee &&
          employee.data &&
          employee.data.length > 0 &&
          employee.data
           
            .map((c) =>
              Object.assign(
                {},
                {
                  label:c.empCode.concat(" - ", c.name),
                  value: c._id,
                  
                }
              )
            )) ||
        [],
        followUpStrategyOptions:
        (followupStrategy &&
          followupStrategy.data &&
          followupStrategy.data.length > 0 &&
          followupStrategy.data.filter(_=> _.status === 1).map((e) =>
            Object.assign(
              {},
              {
                label: `${e.followupStrategy}`,
                value: e._id,
              }
            )
          )) ||
        [],
        followUpModeOptions:
        (followupMode &&
          followupMode.data &&
          followupMode.data.length > 0 &&
          followupMode.data.filter(_=> _.status === 1).map((e) =>
            Object.assign(
              {},
              {
                label: `${e.followupMaster}`,
                value: e._id,
              }
            )
          )) ||
        [],
        followUpStatusOptions:
        (followupAction &&
          followupAction.data &&
          followupAction.data.length > 0 &&
          followupAction.data.filter(_=> _.status === 1).map((e) =>
            Object.assign(
              {},
              {
                label: `${e.followupAction}`,
                value: e._id,
              }
            )
          )) ||
        [],
        rejectOptions:
        (reject &&
          reject.data &&
          reject.data.length > 0 &&
          reject.data
            .map((c) =>
              Object.assign(
                {},
                {
                  label:c.reason,
                  value: c._id,
                  
                }
              )
            )) ||
        [],
        clientProfileOptions:
        (clientProfile && clientProfile.data && clientProfile.data.length > 0 &&
            clientProfile.data.map(c => Object.assign({}, { label: c.clientProfile, value: c._id }))) || [],
      }

      yield put(loadRecordsMetaDataSuccess(permissionMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* addFollowUpSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_FOLLOWUP),
    })
    const {followupValues } = add || {}
    if (add) {
      try {
        yield call(addFollowUpAPI, followupValues)
        yield put(
          addFollowUpSuccess(
            followupValues,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          addFollowUpError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}


function* updateSubStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_SUBSTATUS),
    })
    const {subStatusValues } = add || {}
    if (add) {
      try {
        yield call(updateSubStatusAPI, subStatusValues)
        yield put(
          updateSubStatusSuccess(
            subStatusValues,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          updateSubStatusError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}



function* updateRejectSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_REJECT),
    })
    const {rejectValues } = add || {}
    if (add) {
      try {
        yield call(updateRejectAPI,rejectValues)
        yield put(
          updateRejectSuccess(
            rejectValues,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          updateRejectError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}


function* loadRecordsAttachmentDetailDataSaga() {
  while (true) {
    yield race({
      create: take(LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD),
    })
    try {
      const attachmentData = yield call(loadRecordsAttachmentDetailData)
      let recordsAttachmentData =
        attachmentData && attachmentData.data && attachmentData.data.length > 0
          ? attachmentData.data
          : []
      yield put(loadRecordsAttachmentDetailDataSuccess(recordsAttachmentData))
    } catch (error) {
      yield put(
        loadRecordsAttachmentDetailDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}


function* uploadFollowupAttachmentRecordDataSaga() {
  while (true) {
    const { create } = yield race({
      create: take(UPLOAD_FOLLOW_ATTACHMENT_RECORD),
    })

    const { uploadRecord } = create || {}

    if (create) {
      try {
        const attachmentData = yield call(
          uploadFollowupAttachmentRecordData,
          uploadRecord
        )
        let recordsAttachmentData =
          attachmentData &&
          attachmentData.data &&
          attachmentData.data.length > 0
            ? attachmentData.data
            : []
        yield put(
          uploadFollowupAttachmentRecordDataSuccess(recordsAttachmentData)
        )
      } catch (error) {
        yield put(
          uploadFollowupAttachmentRecordDataError(
            (error && error.response && error.response.message) ||
              "Fetch Dropdown Records Failed"
          )
        )
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadMyHighValueLeadSaga(),
    addFollowUpSaga(),
    updateSubStatusSaga(),
    updateRejectSaga(),
    uploadFollowupAttachmentRecordDataSaga(),
    loadRecordsAttachmentDetailDataSaga()
  ])
}
